import React from "react";
import i18n from '../../i18n';
import { connect } from 'react-redux'

class PaletteItemTooltipContentClass extends React.Component {

  render() {
    const PaletteItemContents = {
      ratio: {
        title: i18n.t("paletteitemtooltipcontent.ratio.title"),
        content:
          i18n.t("paletteitemtooltipcontent.ratio.contnent1"),
        color: "#F69F5A"
      },
      music: {
        title: i18n.t("paletteitemtooltipcontent.music.title"),
        content:
          i18n.t("paletteitemtooltipcontent.music.contnent1") +
          i18n.t("paletteitemtooltipcontent.music.contnent2"),
        color: "#F69F5A"
      },
      media: {
        title: i18n.t("paletteitemtooltipcontent.media.title"),
        content:
          i18n.t("paletteitemtooltipcontent.media.content"),
        color: "#F69F5A"
      },
      image: {
        title: i18n.t("paletteitemtooltipcontent.image.title"),
        content:
          i18n.t("paletteitemtooltipcontent.image.contnent1") +
          i18n.t("paletteitemtooltipcontent.image.contnent2")
      },
      video: {
        title: i18n.t("paletteitemtooltipcontent.video.title"),
        content:
          i18n.t("paletteitemtooltipcontent.video.contnent1") + ` ` +
          i18n.t("paletteitemtooltipcontent.video.contnent2")
      },
      unsplash: {
        title: i18n.t("paletteitemtooltipcontent.unsplash.title"),
        content:
          i18n.t("paletteitemtooltipcontent.unsplash.contnent1") +
          i18n.t("paletteitemtooltipcontent.unsplash.contnent2")
      },
      pexels: {
        title: i18n.t("paletteitemtooltipcontent.pexels.title"),
        content:
          i18n.t("paletteitemtooltipcontent.pexels.contnent1") +
          i18n.t("paletteitemtooltipcontent.pexels.contnent2")
      },
      pixabay: {
        title: i18n.t("paletteitemtooltipcontent.pixabay.title"),
        content:
          i18n.t("paletteitemtooltipcontent.pixabay.contnent1") +
          i18n.t("paletteitemtooltipcontent.pixabay.contnent2")
      },
      font: {
        title: i18n.t("paletteitemtooltipcontent.font.title"),
        content:
          i18n.t("paletteitemtooltipcontent.font.contnent2"),
        color: "#F69F5A"
      },
      disableFont: {
        title: i18n.t("paletteitemtooltipcontent.font.title"),
        content:
          i18n.t("paletteitemtooltipcontent.font.disable.contnent2"),
        color: "#F69F5A"
      },
      preview: {
        title: i18n.t("paletteitemtooltipcontent.preview.title"),
        content:
          i18n.t("paletteitemtooltipcontent.preview.contnent1") +
          i18n.t("paletteitemtooltipcontent.preview.contnent2")
      },
      preview_nopayment: {
        title: i18n.t("paletteitemtooltipcontent.preview.title"),
        content:
          i18n.t("paletteitemtooltipcontent.preview.nopayment.contnent1")
      },
      preview_error: {
        title: i18n.t("paletteitemtooltipcontent.preview.title"),
        content:
          i18n.t("paletteitemtooltipcontent.preview.check")
      },
      finishRendering: {
        title: i18n.t("paletteitemtooltipcontent.finishRendering.title"),
        content:
          i18n.t("paletteitemtooltipcontent.finishRendering.contnent1") +
          i18n.t("paletteitemtooltipcontent.finishRendering.contnent2") +
          i18n.t("paletteitemtooltipcontent.finishRendering.contnent3")
      },
      tempSave: {
        title: i18n.t("paletteitemtooltipcontent.tempSave.title"),
        content:
          i18n.t("paletteitemtooltipcontent.tempSave.contnent1")
      },
      textInput: {
        title: i18n.t("paletteitemtooltipcontent.textInput.title"),
        content:
          i18n.t("paletteitemtooltipcontent.textInput.contnent1")
      },
      imageInput: {
        title: i18n.t("paletteitemtooltipcontent.imageInput.title"),
        content:
          i18n.t("paletteitemtooltipcontent.imageInput.contnent1")
      },
      warningInput: {
        title: i18n.t("paletteitemtooltipcontent.warningInput.title"),
        content:
          i18n.t("paletteitemtooltipcontent.warningInput.contnent1")
      },
      warningTextEmpty: {
        title: i18n.t("paletteitemtooltipcontent.warningTextEmpty.title"),
        content:
          i18n.t("paletteitemtooltipcontent.warningTextEmpty.contnent1")
      },
      warningImageEmpty: {
        title: i18n.t("paletteitemtooltipcontent.warningImageEmpty.title"),
        content:
          i18n.t("paletteitemtooltipcontent.warningImageEmpty.contnent1")
      },
      freeImage: {
        title: i18n.t("paletteitemtooltipcontent.freeImage.title"),
        content:
          i18n.t("paletteitemtooltipcontent.freeImage.contnent1")
      },
      gettyvideo: {
        title: i18n.t("paletteitemtooltipcontent.gettyvideo.title"),
        content:
          i18n.t("paletteitemtooltipcontent.gettyvideo.contnent1"),
        color: "#F69F5A"
      },
      disableGettyvideo: {
        title: i18n.t("paletteitemtooltipcontent.gettyvideo.title"),
        content:
          i18n.t("paletteitemtooltipcontent.gettyvideo.contnent1") +
          i18n.t("paletteitemtooltipcontent.disableGettyvideo.contnent2"),
        color: "#F69F5A"
      },
      textAble: {
        title: i18n.t("paletteitemtooltipcontent.textAble.title"),
        content:
          i18n.t("paletteitemtooltipcontent.textAble.contnent1"),
        color: "#F69F5A"
      },
      textDisable: {
        title: i18n.t("paletteitemtooltipcontent.textDisable.title"),
        content:
          i18n.t("paletteitemtooltipcontent.textDisable.contnent1"),
        color: "#F69F5A"
      },
      uploadFont: {
        title: i18n.t("paletteitemtooltipcontent.uploadFont.title"),
        content:
          i18n.t("paletteitemtooltipcontent.uploadFont.contnent1"),
        color: "#F69F5A"
      },
      copyright: {
        title: i18n.t("makevideo.musicpalette.copyright.notice.title"),
        content:
          i18n.t("makevideo.musicpalette.copyright.notice.message"),
        color: "#F69F5A"
      },
      applyMusic: {
        title: i18n.t("makevideo.musicpalette.applyMusic.notice.title"),
        content:
          i18n.t("makevideo.musicpalette.applyMusic.notice.message"),
        color: "#F69F5A"
      },
      regulationsForUseOfPointShop: {
        title: i18n.t("web.my.point.terms.of.use.btn.label").replace("\n\r", " "),
        content: i18n.t("web.my.point.terms.of.use.contents")
      },
      textCopyRight:{
        title: i18n.t("makevideo.fontpalette.copyright.notice.title"),
        content:
          i18n.t("makevideo.fontpalette.copyright.notice.message"),
        color: "#F69F5A"
      },
      lengthAdjust: {
        title: i18n.t("makevideo.lengthAdjustPalette.notice.title"),
        content: i18n.t("makevideo.lengthAdjustPalette.notice.message"),
        color: "#F69F5A"
      }
      ,
      lengthAdjustDisabled: {
        title: i18n.t("makevideo.lengthAdjustPalette.notice.title"),
        content: i18n.t("makevideo.lengthAdjustPalette.notice.message.disable"),
        color: "#F69F5A"
      },
      workspace:{
        title: i18n.t("makevideo.workspace.palette.title"),
        content: i18n.t("makevideo.workspace.notice.message"),
        color: "#F69F5A"
      },
      aiTool:{
        title: i18n.t("makevideo.aiTool.notice.title"),
        content: i18n.t("makevideo.aiTool.notice.message"),
        color: "#F69F5A"
      }
    };

    const { kind, additionalContent } = this.props;
    const { title, content, color } = PaletteItemContents[kind];

    return (
      <div style={{ padding: "10px", whiteSpace: "pre-line" }}>
        <div
          style={{
            fontSize: "15px",
            fontWeight: "bold",
            paddingBottom: "10px",
            color: color || "#8Ec83E"
          }}
        >
          {title}
        </div>
        <div
          style={{
            whiteSpace: "pre-line",
            color: "#fff",
            wordBreak: this.props.lang === 'jp' ? "break-all" : "keep-all"
          }}
        >
          {content}{additionalContent}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lang: state.langStore.lang
})

export const PaletteItemTooltipContent = connect(mapStateToProps, null)(PaletteItemTooltipContentClass)